import React, { useEffect, useState } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { OCCUPANCY_COUNTBOX_LIST } from '../../../../constants/DashboardConst';
import CustomCountBox from '../../../../shared/custom-count-box/Custom-Count-Box';
import {
  occuppancyCheckinSelector,
  occuppancyOrdersSelector,
} from '../../../../layouts/home/DashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getOccupancyCounts } from '../../../../utils/dashboardUtils';
import {
  digitalCheckInSelector,
  fetchDigitalCheckInDetails,
} from '../../../../layouts/analytics/AnalyticsSlice';
import { selectedHotelSelector } from '../../../../layouts/property/propertySlice';
import moment from 'moment/moment';

const OccupancyTabDetail = (props) => {
  const [orderCountList, setOrderCountList] = useState(OCCUPANCY_COUNTBOX_LIST);
  const roomStatus = useSelector(occuppancyOrdersSelector);
  const digitalCheckInData = useSelector(digitalCheckInSelector);
  const hotelId = useSelector(selectedHotelSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    onFetchDigitalCheckInData();
  }, [hotelId]);

  const onFetchDigitalCheckInData = () => {
    const payload = {
      hotelId,
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      channel: '',
    };
    dispatch(fetchDigitalCheckInDetails(payload));
  };

  useEffect(() => {
    setOrderCountList(getOccupancyCounts(orderCountList, roomStatus, digitalCheckInData));
  }, [roomStatus, digitalCheckInData]);

  return (
    <>
      <div className='row'>
        <div className='col col-md-10'>Occupancy</div>
      </div>
      {orderCountList?.length > 0 && (
        <div>
          <div className='px-1 py-2 d-flex flex-wrap gap-3 col-12 justify-content-start'>
            {orderCountList?.map((currentCount, countNdx) => (
              <CustomCountBox
                count={currentCount}
                className={'occuppancy-count-box col'}
                key={countNdx}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default OccupancyTabDetail;
